import {
  Befehl1Icon,
  Befehl2Icon,
  Befehl3Icon,
  Befehl4Icon,
  Befehl5Icon,
  Befehl6Icon,
  Befehl7Icon,
  Befehl8Icon,
  Befehl9Icon,
  Befehl21Icon,
  Befehl22Icon,
  Befehl23Icon,
  Befehl24Icon,
  Befehl25Icon,
  Befehl26Icon,
  Befehl27Icon,
  Befehl28Icon,
  Befehl29Icon,
  Befehl30Icon,
  Befehl31Icon,
  Befehl32Icon,
  Befehl33Icon,
  Befehl34Icon,
  Befehl95Icon
} from './icons'

export function useBefehlIcon(kennung: string) {
  switch (kennung) {
    case '1':
      return Befehl1Icon
    case '2':
      return Befehl2Icon
    case '3':
      return Befehl3Icon
    case '4':
      return Befehl4Icon
    case '5':
      return Befehl5Icon
    case '6':
      return Befehl6Icon
    case '7':
      return Befehl7Icon
    case '8':
      return Befehl8Icon
    case '9':
      return Befehl9Icon
    case '21':
      return Befehl21Icon
    case '22':
      return Befehl22Icon
    case '23':
      return Befehl23Icon
    case '24':
      return Befehl24Icon
    case '25':
      return Befehl25Icon
    case '26':
      return Befehl26Icon
    case '27':
      return Befehl27Icon
    case '28':
      return Befehl28Icon
    case '29':
      return Befehl29Icon
    case '30':
      return Befehl30Icon
    case '31':
      return Befehl31Icon
    case '32':
      return Befehl32Icon
    case '33':
      return Befehl33Icon
    case '34':
      return Befehl34Icon
    case '95':
      return Befehl95Icon
    default:
      throw new Error(
        `Es konnte kein BefehlIcon für die Kennung "${kennung}" gefunden werden.`
      )
  }
}
